import { Component } from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-evaluation',
  templateUrl: './evaluation.component.html',
  styleUrls: ['./evaluation.component.css']
})
export class EvaluationComponent extends GeneralComponent {

  allQuestions: any = {};
  examId: number;
  sum: number;
  maxSum:number;

  constructor(protected topicService: TopicService, activatedRoute: ActivatedRoute) {
    super(topicService);
      this.examId = +activatedRoute.snapshot.paramMap.get('id');
      if (this.topicService.isExam(this.examId)) {
        this.topicService.setQuestionsSolved(this.examId);
      }
  }

  ngOnInit() {
    this.allQuestions = this.topicService.getAllQuestionInfosById(this.examId);
    this.sum = 0;
    this.maxSum = 0;
    for(let question of this.allQuestions){
      this.sum += question.evaluate;
      this.maxSum += question.maxPoints;
    }
  }

}
